// src/Components/Hooks/UserHooks.js
import { useEffect, useState } from "react";
import { getLoggedinUser, getAuthToken } from "../../helpers/api_helper";

const useProfile = () => {
  // Get user and token from localStorage
  const userProfileSession = getLoggedinUser();
  const token = getAuthToken();

  const [loading, setLoading] = useState(userProfileSession ? false : true);
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const userProfileSession = getLoggedinUser();
    setUserProfile(userProfileSession ? userProfileSession : null);
    // finished checking for userProfile, set loading to false
    setLoading(false); 
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
